<template>
  <div class="b-service">
    <span class="bs-time" @click="$emit('leaveClick')"><i class="m-icon"></i>预约看房</span>
    <span class="bs-tell" @click="$emit('callClick')"><i class="m-icon"></i> <a :href="'tel:'+phone">免费通话</a></span>
  </div>
</template>

<script>
export default {
  name: 'Service',
  props:{
    phone:String,
  },
  data(){
    return{
    }
  },
}
</script>

<style scoped>
  .b-service{position:fixed;left:0;right:0;bottom:0;z-index:8;height:50px;box-shadow:0 -3px 15px 0 rgba(0, 0, 0, 0.1);background:#fff;text-align:center;line-height:50px;}
  .bs-time{float:left;width:40%;color:#b6b5b2;}
  .bs-tell{float:left;width:60%;background:linear-gradient(90deg, #ff4d30 0%,#ff845e 100%);
    color:#fff;}
  .b-service .m-icon{width:20px;height:20px;vertical-align:top;margin-top:15px;margin-right:6px;}
  .bs-time .m-icon{background-position:-201px 0;}
  .bs-tell .m-icon{background-position:-201px -21px;}
</style>



// WEBPACK FOOTER //
// src/components/public/Service.vue